import { FC, useState, useEffect } from 'react';
import s from './QuantityCards.module.scss';
import { usewpdataSelectors } from '@lib/wpdataState/selectors';
import { useproductsdataSelectors } from '@lib/productsState/selectors';
import QuantityCardBundles from './QuantityCardBundles';
import Button from 'components/Button/CTA/Button';
import QuantityIncrementer from '../qtyIncrementer/QuantityIncrementer';
import { useCartActions } from 'lib/cartState/actions';
import { ProductCartItem } from 'lib/cartState/slice';
import { useCartSelectors } from '@lib/cartState/selectors';

const QuantityCards: FC = () => {
  const { Settings, hero } = usewpdataSelectors();
  const { Products } = useproductsdataSelectors();
  const { addMainProductAction, toggleCartAction } = useCartActions();
  const [selectedItem, setSelectedItem] = useState<ProductCartItem | null>(null);
  const [active, setActive] = useState('');
  const { cartProducts } = useCartSelectors();

  const currenctPrice = cartProducts
    .filter((item) => item.type === 'offer')
    .reduce((acc, item) => acc + item.price * item.amount, 0)
    .toFixed(2);

  useEffect(() => {
    let defaultProductIndex = Products.findIndex((item: ProductCartItem) => item.best_seller === true);
    defaultProductIndex === -1 ? (defaultProductIndex = 0) : defaultProductIndex;
    setActive(Products[defaultProductIndex].id);

    if (Settings.emptyCart) {
      setSelectedItem({ ...Products[defaultProductIndex], type: 'offer' });
    } else {
      addMainProductAction({ ...Products[defaultProductIndex], type: 'offer' }, Settings.emptyCart);
    }
  }, []);

  return (
    <section className={s.quantity} id="product-picker">
      <div className={s.quantity__cardList}>
        {Products &&
          Products.map((item: ProductCartItem) => (
            <QuantityCardBundles
              setActive={setActive}
              active={active === item.id}
              setSelectedProduct={setSelectedItem}
              key={item.id}
              id={item.id}
              amount={item.amount}
              status={item?.status}
              display_name={item.display_name}
              generic_name={item.generic_name}
              thank_you_displayed_name={item?.thank_you_displayed_name || ''}
              description={item.description}
              price={item.price}
              image={item.image}
              old_price={item.old_price}
              bundle_products={item.bundle_products}
              best_seller={item.best_seller || false}
              best_value={item.best_value || false}
              warranty_price={item.warranty_price || 0}
              shipping_price={item.shipping_price || 0}
              fake_products={item.fake_products || undefined}
            />
          ))}
      </div>

      <div className={`${s.ctaWrapper} ${Settings?.showQtyIncrementer ? s.ctaWrapper__bundle : ''}`}>
        {Settings?.showQtyIncrementer && <QuantityIncrementer />}
        <Button
          handleClick={() => {
            if (Settings.emptyCart && selectedItem) {
              addMainProductAction(selectedItem, Settings.emptyCart);
              toggleCartAction();
            } else {
              toggleCartAction();
            }
          }}
          text={`${hero?.ctaButtonText} ${Settings.showPriceInCTA ? `| ${currenctPrice}` : ''}`}
          className={s.ctaButton}
        />
      </div>
    </section>
  );
};

export default QuantityCards;
